import { Grid, Typography } from '@mui/material';
import { type ReactElement } from 'react';
import { useIntl } from 'react-intl';
import { useAppSelector } from '../../../app/hooks';
import DefaultSpacingGrid from '../../../components/Containers/DefaultSpacingGrid';
import { fetchLoggedInUserSelector } from '../../../features/selectors';
import AssetForm from './AssetForm';
import messages from './messages';

const CreateAsset = (): ReactElement<any, any> => {
    const { formatMessage } = useIntl()
    const loggedInUser = useAppSelector(fetchLoggedInUserSelector.data)

    return (
        // eslint-disable-next-line react/jsx-no-undef
        <DefaultSpacingGrid container pt={4}>
            <Grid item xs={12}>
                <Typography variant='h3' align='left' dir='rtl'>
                    {formatMessage(messages.addAsset)}
                </Typography>
            </Grid>
            <Grid display='flex' flexDirection='row' gap={4} width='100%'>
                <Grid display='flex' flexDirection='column' width='50%'>
                    <AssetForm
                        loggedInUser={loggedInUser}
                        type="create"
                    />
                </Grid>
            </Grid>
        </DefaultSpacingGrid>
    )
}

export default CreateAsset
